module.exports = __webpack_public_path__ + "static/media/JinRong3.b2c56e31.png";